import React from 'react';

const LABELS = {
  exact_message_id: 'Exact',
  exact_meta: 'Match',
  content_hash: 'Same content',
  near_duplicate: 'Similar',
};

export default function DuplicateBadge({ matchType, confidence, count }) {
  return (
    <span className={`dup-badge dup-badge-${matchType || 'exact_meta'}`}>
      {LABELS[matchType] || 'Duplicate'}
      {typeof confidence === 'number' ? ` · ${Math.round(confidence * 100)}%` : ''}
      {count > 1 ? ` · ${count}` : ''}
    </span>
  );
}
